import styled from '@emotion/styled';
import React, { FC } from 'react';
import { Image } from '~/shared/components';

interface IProps {
    src?: string;
    alt?: string;
    bordered?: boolean;
}

export const SwatchColor: FC<IProps> = ({ src, alt = '', bordered }) => {
    return (
        <StyledRoot hasImage={!!src} bordered={bordered}>
            {src ? <Image layout="fixed" height={16} width={16} alt={alt} src={src} /> : null}
        </StyledRoot>
    );
};

const StyledRoot = styled.div<{ hasImage?: boolean; bordered?: boolean }>(
    ({ theme, hasImage, bordered }) => ({
        borderRadius: '100%',
        border: `1px solid ${
            bordered ? theme.colors.black : hasImage ? theme.colors.grey30 : 'transparent'
        }`,
        overflow: 'hidden',
        width: theme.space['3'],
        height: theme.space['3'],
        flexShrink: 0,
    }),
);
